import { extendTheme } from '@mui/joy/styles'
const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          solidBg: '#2563eb',
          solidHoverBg: '#1e40af',
          softBg: '#eff6ff',
          softColor: '#1e3a8a',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          solidBg: '#3b82f6',
          solidHoverBg: '#1d4ed8',
          softBg: '#0b1220',
          softColor: '#93c5fd',
        },
      },
    },
  },
  radius: { sm: '8px', md: '12px', lg: '16px' },
  shadow: {
    sm: '0 1px 2px rgba(0,0,0,.06)',
    md: '0 4px 12px rgba(0,0,0,.08)',
    lg: '0 10px 24px rgba(0,0,0,.12)',
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          borderRadius: '999px',
          textTransform: 'none',
          boxShadow: ownerState.variant === 'solid' ? theme.shadow.sm : 'none',
        }),
      },
    },
    JoyCard: {
      styleOverrides: {
        root: ({ theme }) => ({ borderRadius: 16, boxShadow: theme.shadow.sm }),
      },
    },
    JoyChip: { styleOverrides: { root: { borderRadius: 999 } } },
  },
})
export default theme
